import React from "react";
import { Section, CTAButton } from "../ui";

export const WhyCodemixSection = () => (
  <Section title="Why codemix?">
    <p>
      We're a small but determined team of expert software developers and
      designers who specialize in TypeScript.
    </p>
    <p>
      As the leading TS consultancy in the North of England, we work with
      companies large and small to ship web and mobile applications, train
      development teams and conquer deep technical challenges.
    </p>
    <p>
      We love open source and release us much of our work as possible under
      permissive licenses. We spend a lot of our time thinking about how to make
      JavaScript and TypeScript better and pushing the ecosystem forward.
    </p>
    <p>
      Our core values are Speed, Integrity and Pragmatism. We take pride in
      delivering high quality but cost-effective solutions tailored to your
      unique business requirements.
    </p>
    <p>
      To find out how codemix can help you get more out of TypeScript,{" "}
      <CTAButton to="/contact">Contact Us</CTAButton>
    </p>
  </Section>
);
